import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../constant/routeConstant';
import { getDetail } from '../../../../service/setup/UnitOfMeasurement/UomService';

const useDetailUOM = () => {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [showDelete, setShowDelete] = useState(false);

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  }

  const getDetailUOM = async () => {
    try {
      const response = await getDetail(token, null, location?.state?.id, dispatch);
      if (response && response.ok) {
        setData(response.data);
        setLoading(false);
      }
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
    getDetailUOM();
    // eslint-disable-next-line
  }, []);

  const handleBack = () => {
    navigate(ROUTES.UOM.LIST)
  }

  const toEdit = () => {
    navigate(ROUTES.UOM.EDIT, { state: { id: location?.state?.id, prevPage: location?.pathname } });
  }

  const cekCategory = (data) => {
    if (data === "T") {
      return 'Temperature'
    } else if (data === "L") {
      return 'Length'
    } else if (data === "V") {
      return 'Volume'
    } else if (data === "W") {
      return 'Weight'
    } else {
      return '-'
    }
  }

  const UOMConvertions = (data) => {
    if (data === "T") {
      return 'C'
    } else if (data === "L") {
      return 'Cm'
    } else if (data === "V") {
      return 'm^3'
    } else if (data === "W") {
      return 'Kg'
    } else {
      return '-'
    }
  }

  return {
    data,
    handleBack,
    loading,
    toEdit,
    cekCategory,
    UOMConvertions,
    setModal,
    showDelete
  }
}

export default useDetailUOM;